export default __webpack_public_path__ + "static/media/Screenshot (272).ec641d7d.png";